import React from 'react';

const OwnerPage = () => {
  return <div>Laporan Penitip (Kosong)</div>;
};

export default OwnerPage;